<template>
  <div class="hpsfir-card config">
    <el-tabs v-model="activeTab" class="config-tabs">
      <el-tab-pane label="D币套餐" name="recharge">
        <Recharge v-if="activeTab === 'recharge'" />
      </el-tab-pane>
      <el-tab-pane label="存积分规则配置" name="pointsRule">
        <PointsRule v-if="activeTab === 'pointsRule'" />
      </el-tab-pane>
      <el-tab-pane label="邀请奖励配置" name="inviteRule">
        <InviteRule v-if="activeTab === 'inviteRule'" />
      </el-tab-pane>
      <el-tab-pane label="签到赠送积分配置" name="signRule">
        <SignRule v-if="activeTab === 'signRule'" />
      </el-tab-pane>
      <el-tab-pane label="WiFi信息配置" name="wifiConfig">
        <WifiConfig v-if="activeTab === 'wifiConfig'" />
      </el-tab-pane>
      <el-tab-pane label="本店须知与规则" name="storeNotice">
        <StoreNotice v-if="activeTab === 'storeNotice'" />
      </el-tab-pane>
      <el-tab-pane label="今日活动" name="todayActivity">
        <TodayActivity v-if="activeTab === 'todayActivity'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import Recharge from './recharge/index.vue';
import PointsRule from './pointsrule/index.vue';
import InviteRule from './inviterule/index.vue';
import SignRule from './signrule/index.vue';
import WifiConfig from './wificonfig/index.vue';
import StoreNotice from './storenotice/index.vue';
import TodayActivity from './todayactivity/index.vue';

const activeTab = ref('recharge');
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
